export const SAVE_WHITE_LABEL = 'whitelabel/SAVE_WHITE_LABEL';